<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
          <el-breadcrumb-item>类别信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="category" label-width="160px" size="medium">
        <el-form-item label="名称">
          <el-col :span="11">
            <el-input v-model="category.name" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="所属商家">
          <el-col :span="11">
            <el-input v-model="merchantName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectMerchantHandle"></el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属行业">
          <el-select v-model="category.industryId" placeholder="请选择行业">
            <el-option
              v-for="item in industrys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>          
        </el-form-item>
        <el-form-item label="排序">
          <el-col :span="12">
            <el-input-number v-model="category.sort"  :min="1" :max="10000" label="描述文字"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="单位">
          <el-col :span="11">
            <el-input v-model="category.unit"></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="备注">
          <el-col :span="11">
            <el-input v-model="category.memo"></el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="规格">
          <div class="sku_container">
            <div class="sku_group mb10" v-for="(spec, index) in specification" :key="spec.sid">
              <div class="spec_title">
                <span class="label">规格名:</span>
                <el-input class="input" v-model.trim="spec.value" placeholder='请输入规格名' ></el-input>
                <span class="label">，是否SKU：</span>
                <el-switch
                  v-model="spec.isSKU">
                </el-switch>
                <span class="remove" @click="delSepc(index)">X</span>
              </div>
              <div class="group_container"  >
                <span class="lable">规格值:</span>
                <el-popover placement="bottom" width="120" trigger="click"
                  v-for="(option, option_index) in spec.leaf" :key="option_index">                  
                  <el-input v-model.trim="option.value" style="width: 110px;" ></el-input>
                  <div class="sku_item" slot="reference">
                    <span class="remove" @click.stop="delOption(index, option_index)">×</span>
                    <div class="text">{{option.value}}</div>
                  </div>
                </el-popover>
                <el-input suffix-icon="el-icon-plus" style="width:220px"  v-model="addValues[index]" 
                  placeholder="多个产品属性以空格隔开"
                  @keyup.native.enter='addOption(index)'
                  @blur='addOption(index)' >
                </el-input>
              </div>
            </div>
            <div class="spec_title">
              <el-button type="info" :disabled='disabled' @click='addSpec'>添加规格项目</el-button>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveCtegory">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
    <GetMerchant v-bind:dialogMerchant="dialogMerchant" @UpdateMerchant="UpdateMerchant"></GetMerchant> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { createUniqueString, uniqueArr } from '@/utils/index.js'  
  import GetMerchant from '@/components/GetMerchant'
  export default {
    props:{
    },
    data (){
      return {
        category:{},
        industrys:[],
        addValues: [],
        specification:[],
        dialogMerchant:{
          isShow:false
        },
        merchantName:''
      }
    },
    computed:{
      disabled() {        
        return this.specification.length > 3 || this.specification.some(item => !item.value)
      },   
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/ProductCategory/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.category = resp.data.category
        that.merchantName = resp.data.merchantName
        that.industrys = resp.data.industrys  
        that.specification = resp.data.specifications    
      })
    },
    methods:{
      SaveCtegory:function(){
        var that = this
        that.category.Specifications = JSON.stringify(that.specification)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ProductCategory/Save',         
          data:that.category
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      addSpec() {
        this.specification.push({
          sid: createUniqueString() + '_id',
          text: '',
          leaf: [],
        })
      },    
      selectMerchantHandle:function(){
        this.dialogMerchant.isShow = true
      },  
      UpdateMerchant(id,name){
        this.merchantName = name
        this.category.merchantId = id
      },
      delSepc(index) {
        this.specification.splice(index, 1)
      },
      addOption(index) {
        let str = this.addValues[index] || ''
        str = str.trim()
        if (!str) return        
        const oldArr = this.specification[index].leaf
        const arr = str
                  .split(/\s+/) // 使用空格分割成数组
                  .filter(value => !oldArr.some(option => option.value === value)) // 过滤掉 oldArr 已存在的 value
                  .map(value => ({ sid: createUniqueString() + '_id', value })) // 把 value 转成对象，id 设置为 null
        this.specification[index].leaf = uniqueArr([...oldArr, ...arr])
        this.$set(this.addValues, index, '')
      },
      delOption(spec_index, option_index) {
        this.specification[spec_index].leaf.splice(option_index, 1)
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'productCategory',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
      GetMerchant
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
  .sku_container
    margin-bottom 30px
    font-size 12px
    color #666
    padding 10px
    border 1px solid #e5e5e5
  .remove
    display none
    position absolute
    z-index 2
    width 18px
    height 18px
    font-size 14px
    line-height 16px
    color #fff
    text-align center
    cursor pointer
    background rgba(0,0,0,.3)
    border-radius 50%
  .sku_group
    margin-bottom 10px
    &:hover
      .spec_title .remove
        display block
  .spec_title
    position relative
    padding 7px 10px
    background-color #f8f8f8
    line-height 16px
    font-weight 400
    .input
      width 200px
    .remove
      top 12px
      right 10px
  .group_container
    padding 10px 10px 0
    .input
      width 250px
    .sku_item
      background-color #f8f8f8
      padding 10px
      display inline-block
      margin-right 10px
      vertical-align middle
      text-align center
      position relative
      border-radius 2px
      cursor pointer
      line-height 25px
      &:hover
        .remove
          display block
      .remove
        top -8px
        right -8px
      .text
        display block
        width 74px
        margin 0 auto
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
</style>